import { useContext } from "react";
import useErrorHandler from "@beeldit/core/errors/useErrorHandler";
import update from "@beeldit/core/services/update";
import { EditShippingAddressActionContext } from "./EditShippingAddressActionContext";

function useUpdate() {
  const { element, setBackendFormErrors } = useContext(
    EditShippingAddressActionContext
  );
  const errorHandler = useErrorHandler();

  return (onSuccess: any) => {
    const dataToSend = {
      ...element,
      type: "shipment",
    };

    update("super-orders", element.id, dataToSend)
      .then((response: any) => {
        onSuccess(response.data);
        setBackendFormErrors({}); // Clear backend errors on success
      })
      .catch((error: any) => {
        errorHandler(error, setBackendFormErrors);
      });
  };
}

export default useUpdate;
